'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_NotFoundPage$() {
}
export { $c_Lapp_pages_NotFoundPage$ as $c_Lapp_pages_NotFoundPage$ };
$p = $c_Lapp_pages_NotFoundPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_NotFoundPage$;
/** @constructor */
function $h_Lapp_pages_NotFoundPage$() {
}
export { $h_Lapp_pages_NotFoundPage$ as $h_Lapp_pages_NotFoundPage$ };
$h_Lapp_pages_NotFoundPage$.prototype = $p;
$p.gN = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
    var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if (((x === null) ? (x$1 === null) : (x === x$1))) {
      return "Page Not Found";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().ay());
});
$p.au8 = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_PageRenderResult($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().b.af().o($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().b, "The page you are looking for does not exist.", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_modifiers_RenderableText$().S)]))), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_PageTitleResult$().j3);
});
var $d_Lapp_pages_NotFoundPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_NotFoundPage$, "app.pages.NotFoundPage$", ({
  HM: 1
}));
export { $d_Lapp_pages_NotFoundPage$ as $d_Lapp_pages_NotFoundPage$ };
var $n_Lapp_pages_NotFoundPage$;
function $m_Lapp_pages_NotFoundPage$() {
  if ((!$n_Lapp_pages_NotFoundPage$)) {
    $n_Lapp_pages_NotFoundPage$ = new $c_Lapp_pages_NotFoundPage$();
  }
  return $n_Lapp_pages_NotFoundPage$;
}
export { $m_Lapp_pages_NotFoundPage$ as $m_Lapp_pages_NotFoundPage$ };
//# sourceMappingURL=app.pages.-Not-Found-Page$.js.map
